export default {
  AU: '+61',
  MY: '+60',
  NZ: '+64'
}